/** Individual purchase flow selection step */
export enum SelectionStep {
  CLIENT_SELECTION_STEP = 'CLIENT_SELECTION_STEP',
  CATEGORY_SELECTION_STEP = 'CATEGORY_SELECTION_STEP',
  ADDRESS_SELECTION_STEP = 'ADDRESS_SELECTION_STEP',
  PRODUCT_SELECTION_STEP = 'PRODUCT_SELECTION_STEP',
  INSTRUCTION_SELECTION_STEP = 'INSTRUCTION_SELECTION_STEP',
  VALIDATION_SELECTION_STEP = 'VALIDATION_SELECTION_STEP',
}